import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { useCounter } from '../hooks/useCounter';
function StatItem({
  value,
  suffix,
  label
}: {
  value: number;
  suffix: string;
  label: string;
}) {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  const count = useCounter(value, 2000, isVisible);
  return <div ref={elementRef} className="text-center p-6" data-id="element-99">
      <div className="text-4xl md:text-5xl font-bold text-white mb-2" data-id="element-100">
        {count}
        {suffix}
      </div>
      <div className="text-green-400 font-medium tracking-wide uppercase text-sm" data-id="element-101">
        {label}
      </div>
    </div>;
}
export function Stats() {
  return <section className="py-16 bg-slate-900 border-t border-slate-800" data-id="element-102">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-y md:divide-y-0 md:divide-x divide-slate-800" data-id="element-104">
          <StatItem value={500} suffix="+" label="Projects Completed" data-id="element-105" />
          <StatItem value={150} suffix="%" label="Avg Traffic Increase" data-id="element-106" />
          <StatItem value={98} suffix="%" label="Client Satisfaction" data-id="element-107" />
          <StatItem value={10} suffix="+" label="Years Experience" data-id="element-108" />
        </div>
      </div>
    </section>;
}